import { ReduxActionTypes } from "constants/ReduxActionConstants";
import { createAction } from "utils/ActionUtils";

export const fetchAccountDeletionPreflight = () =>
  createAction(ReduxActionTypes.FETCH_ACCOUNT_DELETION_PREFLIGHT, undefined);

export const fetchAccountDeletionPreflightSuccess = (data: any) =>
  createAction(ReduxActionTypes.FETCH_ACCOUNT_DELETION_PREFLIGHT_SUCCESS, data);

export const deleteAccount = (reason: string) =>
  createAction(ReduxActionTypes.DELETE_ACCOUNT, reason);

export const deleteAccountSuccess = () =>
  createAction(ReduxActionTypes.DELETE_ACCOUNT_SUCCESS, undefined);

export const deleteAccountFailed = () =>
  createAction(ReduxActionTypes.DELETE_ACCOUNT_FAILED, undefined);
